import * as React from "react";
import * as ReactDOM from "react-dom";
import hoistNonReactStatics from "hoist-non-react-statics";

export interface IClickOutsideHandler {
  handleClickOutside: (e?: any) => void;
}

export function enhanceWithClickOutside(Component: React.ComponentType<any>) {
  class EnhancedComponent extends React.Component<any, {}> {
    wrappedDOMNode!: React.ReactNode;
    wrappedInstance!: React.ComponentType<any> & IClickOutsideHandler;

    constructor(props) {
      super(props);
      this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
      document.addEventListener("click", this.handleClickOutside, true);
    }

    componentWillUnmount() {
      document.removeEventListener("click", this.handleClickOutside, true);
    }

    handleClickOutside(e) {
      if (
        (!this.wrappedDOMNode ||
          !(this.wrappedDOMNode as any).contains(e.target)) &&
        this.wrappedInstance
      ) {
        this.wrappedInstance.handleClickOutside(e);
      }
    }

    render() {
      const { wrappedRef, ...rest } = this.props;

      return (
        <Component
          {...rest}
          ref={c => {
            this.wrappedDOMNode = ReactDOM.findDOMNode(c);
            this.wrappedInstance = c;
            wrappedRef && wrappedRef(c);
          }}
        />
      );
    }
  }

  return hoistNonReactStatics(EnhancedComponent, Component);
}
